import * as React from "react";
import { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import DownloadIcon from "@mui/icons-material/Download";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import SharePointService from "../services/sharepoint.service";

export default function CommonDocuments() {
  const [files, setFiles] = useState({});
  const [loading, setLoading] = useState(true);

  const GetSPFiles = async () => {
    try {
      setLoading(true);
      const response = await SharePointService.getCommonDocuments();
      setFiles(response || {});
    } catch (error) {
      console.error("Fehler beim Abrufen der Dateien:", error);
      setFiles({});
    } finally {
      setLoading(false);
    }
  };

    const SPfetchFile = async (file) => {
        try {
            let SPfile = await SharePointService.getDownloadFile(file);
            console.log(SPfile)
            if (!SPfile) {
                console.error("Fehler: Keine Datei erhalten");
                return;
            }

            const blob = new Blob([SPfile], { type: "application/octet-stream" });

            // Download-Link erzeugen
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute("download", file.name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Fehler beim Herunterladen der Datei:", error);
        }
    };    

    useEffect(() => {
        GetSPFiles();
    }, []);

  return (
    <Box sx={{ width: "100%" }} mt={4}>
      {loading ? (
        <Box py={10} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : Object.keys(files).length === 0 ? (
        <></>
      ) : (
        <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Paper elevation={0} sx={{ p: 0, textAlign: { xs: 'left', lg: 'center' } }}>
                    <Typography variant="h6">Allgemeine Informationen zum Download</Typography>

                    {Object.keys(files).map((projectName, index) => (
                        <Grid item xs={12} key={index}>
                            <Box p={3}>
                            <Typography variant="h6" fontWeight={'bold'} mb={2}>
                                {projectName}
                            </Typography>
                            <Table>
                                <TableHead>
                                <TableRow>
                                    <TableCell>Dateiname</TableCell>
                                    <TableCell align="right">Download</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {files[projectName].map((file, idx) => (
                                    <TableRow key={idx}>
                                    <TableCell
                                        sx={{ "&:hover": { cursor: "pointer" } }}
                                        onClick={() => SPfetchFile(file)}
                                    >
                                        {file.name}
                                    </TableCell>
                                    <TableCell
                                        align="right"
                                        sx={{ "&:hover": { cursor: "pointer" } }}
                                        onClick={() => SPfetchFile(file)}
                                    >
                                        <DownloadIcon />
                                    </TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                            </Box>
                        </Grid>
                    ))}
                </Paper>
              </Grid>
            </Grid>
        </Grid>
      )}
    </Box>
  );
}
